const validityExpired = (validity) => {
  if (!validity) return true;
  const currentDate = new Date();
  const validityDate = new Date(validity);
  return currentDate > validityDate;
};

export default validityExpired;
